import React, { PureComponent } from 'react';
import withStyles from '@mui/styles/withStyles';
import { connect } from 'react-redux';
import * as selectors from '../store/selectors';
import * as notificationActions from '../store/notification.actions';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const AUTO_HIDE_DURATION = 4000;

const noop = () => {};

class NotificationSnackbar extends PureComponent {
  render() {
    const { notification, classes, hideNotification } = this.props;
    return (
      <Snackbar
        className={classes.snackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={!!notification.message}
        autoHideDuration={AUTO_HIDE_DURATION}
        ClickAwayListenerProps={{
          onClickAway: noop,
        }}
        onClick={hideNotification}
        onClose={hideNotification}
      >
        <Alert className={classes.alert} severity={notification.severity}>
          {notification.message}
        </Alert>
      </Snackbar>
    );
  }
}

const styles = theme => ({
  alert: {
    pointerEvents: 'none',
  },
  snackbar: {
    top: props =>
      props.notification.top
        ? `${props.notification.top + theme.spacing(1).replace('px')}px`
        : undefined,
  },
});

const connectComp = connect(
  state => ({
    notification: selectors.getNotification(state),
  }),
  {
    hideNotification: notificationActions.hideNotification,
  }
);

export default connectComp(withStyles(styles)(NotificationSnackbar));
